/** Display Mega Menu and correct tab when nav item is clicked */
const megaMenuController = () => {
    let init = () => {
        let megaMenu = document.querySelector('#mega-menu')
        document.addEventListener('click', function (event) {
            if(event.target.matches('.main-navigation .nav-link')){
                event.preventDefault();
                toggleMegaMenu(event.target, megaMenu)
                return false;
            }
            if(!isDescendant(event.target, 'mega-menu') && !event.target.matches('.main-navigation .nav-link') ) {
                if(megaMenu.classList.contains('active')){
                    megaMenu.classList.remove('active')
                    event.preventDefault();
                    return false;
                }
            }
        }, false)
        document.addEventListener('click', function(e){
            if(e.target.matches('#mobile-mega-menu a.nav-link.dropdown-item')){
                window.location.href = e.target.href
            }
        })
    }
    let toggleMegaMenu = (trigger, megaMenu) => {
        let targetData = trigger.dataset.target
        let targetTab = document.querySelector(`[data-menu=${CSS.escape(targetData)}]`)
        if(trigger.classList.contains('mega-menu-trigger')) {
            if (megaMenu.classList.contains('active') && !targetTab.classList.contains('active')){
                toggleMegaTab(targetTab)
                return
            }
            if (megaMenu.classList.contains('active') && targetTab.classList.contains('active')){
                megaMenu.classList.remove('active')
                return
            }
            if (!megaMenu.classList.contains('active')){
                megaMenu.classList.add('active')
                toggleMegaTab(targetTab)
                return
            }
            return
        }
        if(!trigger.classList.contains('mega-menu-trigger')) {
            megaMenu.classList.remove('active')
            return
        }
    }
    let toggleMegaTab = (targetTab) => {
        let megaTabs = document.querySelectorAll('.mega-tab')
        if(megaTabs !== null) {
            [...megaTabs].forEach((megaTab) => {
                megaTab.classList.remove('active')
            })
        }
        targetTab.classList.add('active')
    }
    init();
}

const isDescendant = (el, parentId) => {
    let isChild = false
  
    if (el.id === parentId) { //is this the element itself?
      isChild = true
    }
  
    while (el = el.parentNode) {
      if (el.id == parentId) {
        isChild = true
      }
    }
    
    return isChild
  }

megaMenuController();